import { formatMoney } from '@base/shared';
import { useTranslation } from 'react-i18next';

// Dados de exemplo da vitrine. Nomes próprios e números são dados, não textos de tela.
export const CUSTOMERS = [
  { id: 'c1', name: 'Ana Ribeiro', city: 'Belo Horizonte', late: false, balance: '1250.00' },
  { id: 'c2', name: 'Bruno Costa', city: 'Curitiba', late: true, balance: '380.50' },
  { id: 'c3', name: 'Carla Mendes', city: 'Recife', late: false, balance: '0.00' },
  { id: 'c4', name: 'Diego Alves', city: 'Porto Alegre', late: false, balance: '2140.00' },
];
// Dinheiro em texto decimal (packages/shared/src/money.ts); o gráfico só desenha.
export const SALES = [
  '18400.00',
  '21250.00',
  '19800.00',
  '24600.00',
  '27300.00',
  '25900.00',
] as const;

/** As vendas de jan a jun com o nome do mês no idioma da pessoa. */
export function useSales() {
  const { i18n } = useTranslation();
  return SALES.map((value, i) => ({
    label: new Date(Date.UTC(2026, i, 1)).toLocaleDateString(i18n.language, {
      month: 'short',
      timeZone: 'UTC',
    }),
    value,
  }));
}
export const pointsOf = (sales: { label: string; value: string }[]) =>
  sales.map((p) => ({ label: p.label, value: Number(p.value) }));

export function useMoney() {
  const { i18n } = useTranslation();
  return (amount: string) => formatMoney({ amount, currency: 'BRL' }, i18n.language);
}
